import React, { useState } from "react";
import { useProvince } from "@/contexts/ProvinceContext";
import api from "@/lib/api";
import { toast } from "sonner";
import { Phone } from "lucide-react";

export default function NewsHotline() {
  const { selected } = useProvince();
  const [f, setF] = useState({ title: "", description: "", location: "", contact_name: "", contact_phone: "", contact_email: "" });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/news-tips", { ...f, province_id: selected?.id });
      toast.success("Haber ihbarınız alındı, en kısa sürede değerlendirilecek");
      setF({ title: "", description: "", location: "", contact_name: "", contact_phone: "", contact_email: "" });
    } catch { toast.error("Gönderilemedi"); }
  };
  return (
    <div className="max-w-3xl mx-auto px-4 py-6">
      <div className="flex items-center gap-2 mb-3"><Phone className="w-7 h-7 text-[#e11d2a]" /><h1 className="text-2xl md:text-3xl font-black">Haber Hattı</h1></div>
      <p className="text-gray-600 text-sm mb-5">Gördüğünüz, yaşadığınız veya bildiğiniz haberi bize iletin. Editoryal ekibimiz inceleyip yayınlayacaktır.</p>
      <form onSubmit={submit} className="bg-white border border-gray-100 rounded-lg p-5 grid gap-3">
        <input required value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} placeholder="Haber başlığı" className="px-3 py-2 border border-gray-200 rounded-md text-sm" />
        <textarea required rows={5} value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} placeholder="Haber açıklaması" className="px-3 py-2 border border-gray-200 rounded-md text-sm"></textarea>
        <input value={f.location} onChange={(e) => setF({ ...f, location: e.target.value })} placeholder="Konum" className="px-3 py-2 border border-gray-200 rounded-md text-sm" />
        <div className="grid md:grid-cols-3 gap-3">
          <input value={f.contact_name} onChange={(e) => setF({ ...f, contact_name: e.target.value })} placeholder="İsim" className="px-3 py-2 border border-gray-200 rounded-md text-sm" />
          <input value={f.contact_phone} onChange={(e) => setF({ ...f, contact_phone: e.target.value })} placeholder="Telefon" className="px-3 py-2 border border-gray-200 rounded-md text-sm" />
          <input value={f.contact_email} onChange={(e) => setF({ ...f, contact_email: e.target.value })} placeholder="Email" className="px-3 py-2 border border-gray-200 rounded-md text-sm" />
        </div>
        <button type="submit" className="px-4 py-2 bg-[#e11d2a] text-white rounded-md font-semibold text-sm">Gönder</button>
      </form>
    </div>
  );
}
